export const SEARCH_SET_REQUIRED_FIELD_ERRORS = 'search-set-required-field-errors';

export default function setRequiredFieldErrors({ requiredFieldErrors }) {
  return {
    type: SEARCH_SET_REQUIRED_FIELD_ERRORS,
    payload: { requiredFieldErrors },
  };
}
